import { RoadmapConflictError } from '@/roadmaps/errors/roadmaps-errors';
import {
    multipleColumnObjectsFromResponse,
    multipleItemObjectsFromResponse,
    roadmapObjectFromResponse,
    singleColumnObjectFromResponse,
    singleItemObjectFromResponse,
    updateRoadmapCreatedUpdatedInfoFromResponse,
    updateRoadmapPublishedInfoFromResponse,
} from '@/vuex/modules/roadmaps/utils/roadmaps.utils.js';

import { http } from '@pendo/http';

export async function fetchRoadmaps () {
    return http.get('api/s/_SID_/roadmap/').then((res) => res.data);
}

export async function fetchRoadmap (id) {
    const res = await http.get(`api/s/_SID_/roadmap/${id}`).then((res) => res.data);

    return roadmapObjectFromResponse(res);
}

export async function fetchRoadmapItem (roadmapId, itemId) {
    return http.get(`api/s/_SID_/roadmap/${roadmapId}/item/${itemId}`).then((res) => res.data);
}

export async function createRoadmap (roadmap) {
    return http.post('api/s/_SID_/roadmap', roadmap).then((res) => res.data);
}

export async function updateRoadmap (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http.put(`api/s/_SID_/roadmap/${roadmapId}`, payload).then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function updateRoadmapSubscriptionPermissions (roadmapId, payload) {
    const res = await http
        .patch(`api/s/_SID_/roadmap/${roadmapId}/share/subscription`, payload)
        .then((res) => res.data);

    return roadmapObjectFromResponse(res);
}

export async function addRoadmapUserPermissions (roadmapId, payload) {
    const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/share/user`, payload).then((res) => res.data);

    return roadmapObjectFromResponse(res);
}

export async function updateRoadmapUserPermission (roadmapId, userId, payload) {
    const res = await http
        .patch(`api/s/_SID_/roadmap/${roadmapId}/share/user/${userId}`, payload)
        .then((res) => res.data);

    return roadmapObjectFromResponse(res);
}

export async function removeRoadmapUserPermission (roadmapId, userId) {
    const res = await http.delete(`api/s/_SID_/roadmap/${roadmapId}/share/user/${userId}`).then((res) => res.data);

    return roadmapObjectFromResponse(res);
}

export async function deleteRoadmap (roadmapId) {
    return http.delete(`api/s/_SID_/roadmap/${roadmapId}`);
}

export function updateSwimlanes (roadmapId, swimlanesPayload) {
    return makeRequest(async () => {
        const res = await http
            .put(`api/s/_SID_/roadmap/${roadmapId}/swimlanes`, swimlanesPayload)
            .then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function fetchRoadmapBacklog (roadmapId) {
    const res = await http.get(`api/s/_SID_/roadmap/${roadmapId}/backlog`).then((res) => res.data);

    return multipleItemObjectsFromResponse(res);
}

export async function createRoadmapItem (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/item`, payload).then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return multipleItemObjectsFromResponse(res.items);
    });
}

export async function updateRoadmapItem (roadmapId, payload) {
    const res = await http
        .put(`api/s/_SID_/roadmap/${roadmapId}/item/${payload.item.id}`, payload)
        .then((res) => res.data);

    updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

    return singleItemObjectFromResponse(res.item);
}

export async function updateItemLocations (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http.put(`api/s/_SID_/roadmap/${roadmapId}/locations`, payload).then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function promoteItems (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/items/promote`, payload).then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return multipleItemObjectsFromResponse(res.items);
    });
}

export async function deleteRoadmapItem (roadmapId, itemId, payload) {
    return makeRequest(async () => {
        const res = await http
            .post(`api/s/_SID_/roadmap/${roadmapId}/item/${itemId}/delete`, payload)
            .then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function updateColumn (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http
            .put(`api/s/_SID_/roadmap/${roadmapId}/column/${payload.column.id}`, payload)
            .then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return singleColumnObjectFromResponse(res.column);
    });
}

export async function createColumn (roadmapId, payload) {
    return makeRequest(async () => {
        const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/column`, payload).then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return multipleColumnObjectsFromResponse(res.columns);
    });
}

export async function deleteColumn (roadmapId, columnId, payload) {
    return makeRequest(async () => {
        const res = await http
            .post(`api/s/_SID_/roadmap/${roadmapId}/column/${columnId}/delete`, payload)
            .then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function createIdeaItemOnRoadmap (roadmapId, ideaItem, payload) {
    return makeRequest(async () => {
        const res = await http
            .post(`api/s/_SID_/roadmap/${roadmapId}/vocItem/${ideaItem}`, payload)
            .then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return multipleItemObjectsFromResponse(res.items);
    });
}

export async function promoteIdeaToFeature (roadmapId, itemId) {
    return makeRequest(async () => {
        const res = await http
            .put(`api/s/_SID_/roadmap/${roadmapId}/item/${itemId}/promote`, {})
            .then((res) => res.data);
        updateRoadmapCreatedUpdatedInfoFromResponse(res.roadmapCreatedUpdatedInfo);
        updateRoadmapPublishedInfoFromResponse(res.publishedInfo);

        return singleItemObjectFromResponse(res.item);
    });
}

export async function getRoadmapItemExternalIdeas (roadmapId, itemId) {
    return http.get(`api/s/_SID_/roadmap/${roadmapId}/item/${itemId}/external/idea`).then((res) => res.data);
}

export async function publishRoadmap (roadmapId) {
    return makeRequest(async () => {
        const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/publish`, {}).then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function unpublishRoadmap (roadmapId) {
    return makeRequest(async () => {
        const res = await http.post(`api/s/_SID_/roadmap/${roadmapId}/unpublish`, {}).then((res) => res.data);

        return roadmapObjectFromResponse(res);
    });
}

export async function duplicateRoadmap (roadmapId) {
    return http.post(`api/s/_SID_/roadmap/${roadmapId}/duplicate`, {}).then((res) => res.data);
}

async function makeRequest (task) {
    try {
        return await task();
    } catch (err) {
        if (err.response?.status === 409) {
            throw new RoadmapConflictError(err);
        } else {
            throw err;
        }
    }
}
